import React from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';

const lower = value => value && value.toLowerCase();
const validateAdmins = values => {
    const errors = {};
    if (!values.admins || !values.admins.length) {
        errors.admins = { _error: 'At least one member must be entered' }
    } else {
        const adminsArrayErrors = [];
        values.admins.forEach((admin, adminIndex) => {
            const adminErrors = {};
            if (!admin || !admin.email) {
                adminErrors.email = 'Required';
                adminsArrayErrors[adminIndex] = adminErrors
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(admin.email)) {
                adminErrors.email = 'Invalid email address';
                adminsArrayErrors[adminIndex] = adminErrors
            }
        });
        if(adminsArrayErrors.length) {
            errors.admins = adminsArrayErrors
        }
    }
    return errors
}

const renderField = ({ input, label, type, description, meta: { touched, error, dirty } }) => (
    <div className="form-group">
        <input
            className="form-control"
            {...input}
            type={type}
            placeholder={label}/>
        <span className="input-description">{description}</span>
        <div>
            {touched && error && dirty && <span className="text-danger">{error}</span>}
        </div>
    </div>
)

const renderAdmin = ({ fields, meta: { touched, error } }) => (
    <ul>
        <li>
            <button
                className="btn btn-sec mt-2"
                onClick={() => fields.push({})}><i className="fa fa-plus-circle  font-size-20"></i> </button>
            <div>
            {touched && error && <span className="text-danger">{error}</span>}
            </div>
        </li>
        {fields.map((admin, index) =>
            <li key={index}>
                <a
                   className="pull-right color-gray"
                   title="Remove"
                   onClick={() => fields.remove(index)}> <i className="fa fa-minus-circle font-size-20"></i> </a>
                <Field
                    name={`${admin}.email`}
                    type="email"
                    component={renderField}
                    label="Email"
                    description="Administrator Email"
                    normalize={lower}/>
            </li>
        )}
    </ul>
)

const AdministratorsForm = (props) => {
    const { handleSubmit, submitting } = props;
    return (
        <form onSubmit={handleSubmit}>
            <FieldArray name="admins" component={renderAdmin}/>
            <div>
                <button className="btn btn-block btn-sec mt-3" type="submit" disabled={submitting}>Submit</button>
            </div>
        </form>
    );
}

export default reduxForm({
    form: 'administratorsForm',     // a unique identifier for this form
    validate: validateAdmins
})(AdministratorsForm);



// WEBPACK FOOTER //
// ./src/components/profile/forms/AdministratorsForm.js